function hmUpsellPublicProps(properties) {
  var skip = { 'Código regalo': 1, 'Biberón completo': 1, Pack: 1, Vaso: 1, Producto: 1 };
  var out = {};
  Object.keys(properties || {}).forEach(function (key) {
    if (!key || key.charAt(0) === '_' || skip[key]) return;
    var val = properties[key];
    if (val == null || String(val).trim() === '') return;
    out[key] = String(val);
  });
  return out;
}

function hmUpsellTeatLabel() {
  var lang = '';
  try {
    lang = String((document.documentElement && document.documentElement.lang) || '').toLowerCase();
  } catch (e) {}
  if (lang.indexOf('en') === 0) return 'Teat';
  if (lang.indexOf('it') === 0) return 'Tettarella';
  return 'Tetina';
}

function hmUpsellNamedCopy(offer, variant, color, size) {
  var copied = {};
  var names = (offer && offer.optionNames) || [];
  var used = false;
  (variant.options || []).forEach(function (value, index) {
    if (!value || value === 'Default Title') return;
    var key = names[index];
    if (!key) return;
    if ((color && value === color) || (size && value === size)) {
      copied[key] = String(value);
      used = true;
    }
  });
  if (!used) {
    if (color) copied.Color = String(color);
    if (size) copied['Tamaño'] = String(size);
  }
  if (color) copied._hm_color = String(color);
  if (size) copied._hm_size = String(size);
  return copied;
}

// ---- 2.º biberón: vaso + tetina con el diseño del primero, a precio de pack por mercado ----
var hmUpsellTeatSku = /^T[1-4][LMRC]$/;

// El biberón del carrito es UNA línea fusionada del producto vaso (con la tetina dentro). Solo se ofrece el 2.º
// cuando hay exactamente uno, de un solo biberón («one») y de cantidad 1: así nunca sale un 3.º.
function hmUpsellBottleDesign(offer, items) {
  var ids = (offer && offer.bundle && offer.bundle.bottleIds) || [];
  var bottles = (items || []).filter(function (item) {
    return item && ids.indexOf(String(item.productId)) !== -1;
  });
  if (bottles.length !== 1) return null;
  var line = bottles[0];
  var props = line.properties || {};
  if (props._hm_pack !== 'one' || Number(line.quantity) !== 1) return null;
  var teat = String(props._hm_tetina || '').trim().toUpperCase();
  if (!hmUpsellTeatSku.test(teat)) {
    teat = '';
    Object.keys(props).some(function (key) {
      var value = String(props[key] || '').trim().toUpperCase();
      if (!hmUpsellTeatSku.test(value)) return false;
      teat = value;
      return true;
    });
  }
  var vaso = String(line.sku || '').trim().toUpperCase();
  if (!vaso) vaso = String(props.Vaso || props._hm_vaso || '').split(/[\s·]+/)[0].toUpperCase();
  if (!teat || !vaso) return null;
  var shown = hmUpsellPublicProps(props);
  Object.keys(shown).forEach(function (key) {
    var value = String(shown[key]).toUpperCase();
    if (value === teat || value.indexOf(vaso) === 0) delete shown[key];
  });
  var tetinaProps = Object.assign({}, shown, { _hm_tetina: teat });
  tetinaProps[hmUpsellTeatLabel()] = teat;
  if (props._hm_choice) tetinaProps._hm_choice = String(props._hm_choice);
  return { vaso: vaso, teat: teat, tetinaProps: tetinaProps };
}

function hmUpsellPickBottle(offer, items) {
  var design = hmUpsellBottleDesign(offer, items);
  if (!design) return { variant: null, properties: {} };
  var found = null;
  (offer.variants || []).some(function (variant) {
    var lines = variant.lines || [];
    var bottle = lines.filter(function (line) { return line.role === 'biberon'; })[0];
    var teat = lines.filter(function (line) { return line.role === 'tetina'; })[0];
    if (!bottle || !teat) return false;
    if (String(bottle.sku).toUpperCase() !== design.vaso || String(teat.sku).toUpperCase() !== design.teat) return false;
    found = variant;
    return true;
  });
  if (!found) return { variant: null, properties: {} };
  var bottleLine = (found.lines || []).filter(function (line) { return line.role === 'biberon'; })[0];
  var options = ((bottleLine && bottleLine.options) || []).filter(function (value) { return value && value !== 'Default Title'; });
  var cup = { _hm_vaso: design.vaso };
  if (options[0]) cup._hm_size = String(options[0]).trim();
  if (options[1]) cup._hm_color = String(options[1]).trim();
  return {
    variant: Object.assign({}, found, { lineProps: { biberon: cup, tetina: design.tetinaProps } }),
    properties: {},
  };
}

function hmUpsellPick(offer, items) {
  if (offer && offer.bundle && offer.bundle.bottle) return hmUpsellPickBottle(offer, items);
  var variants = (offer.variants || []).filter(function (variant) {
    return variant && variant.available !== false;
  });
  if (!variants.length) variants = offer.variants || [];
  var fallback = variants[0] || null;
  if (!offer.copyDesign || !fallback) return { variant: fallback, properties: {} };

  var teatLine = null;
  var colorLine = null;
  items.forEach(function (item) {
    var props = (item && item.properties) || {};
    if (!teatLine && (props._hm_tetina || props.Tetina || props.Teat || props.Tettarella)) teatLine = item;
    if (!colorLine && (props._hm_color || props._hm_size || props.Color || props.Colour || props.Colore || props.Cor || props['Tamaño'] || props.Size || props.Misura || props.Tamanho || props.Capacidad)) colorLine = item;
  });

  if (teatLine) {
    var teatProps = teatLine.properties || {};
    var sku = String(teatProps._hm_tetina || teatProps.Tetina || teatProps.Teat || teatProps.Tettarella || '').trim().toUpperCase();
    var bySku = variants.find(function (variant) {
      return String(variant.sku || '').trim().toUpperCase() === sku;
    });
    if (bySku) {
      var copiedTeat = hmUpsellPublicProps(teatProps);
      delete copiedTeat.Tetina;
      delete copiedTeat.Teat;
      delete copiedTeat.Tettarella;
      copiedTeat._hm_tetina = sku;
      if (teatProps._hm_choice) copiedTeat._hm_choice = String(teatProps._hm_choice);
      copiedTeat[hmUpsellTeatLabel()] = sku;
      return { variant: bySku, properties: copiedTeat };
    }
  }

  if (colorLine) {
    var colorProps = colorLine.properties || {};
    var color = colorProps._hm_color || colorProps.Color || colorProps.Colour || colorProps.Colore || colorProps.Cor || '';
    var size = colorProps._hm_size || colorProps['Tamaño'] || colorProps.Size || colorProps.Misura || colorProps.Tamanho || colorProps.Capacidad || colorProps['Capacità'] || colorProps.Capacity || colorProps.Capacidade || '';
    var byOpt = variants.find(function (variant) {
      var opts = variant.options || [];
      var colorOk = !color || opts.indexOf(color) !== -1;
      var sizeOk = !size || opts.indexOf(size) !== -1;
      return (color || size) && colorOk && sizeOk;
    });
    if (byOpt) return { variant: byOpt, properties: hmUpsellNamedCopy(offer, byOpt, color, size) };
  }

  return { variant: fallback, properties: {} };
}

function hmUpsellDiscount(offer) {
  // Una oferta con pack (p. ej. el 2.º biberón) cobra el precio del pack por mercado; el descuento suelto no se aplica al pagar.
  if (offer && offer.bundle) return null;
  var type = offer && offer.discountType;
  var amount = Number(String((offer && offer.discountValue) || '').replace(',', '.').trim());
  if ((type !== 'percent' && type !== 'fixed') || !amount || amount <= 0) return null;
  if (type === 'percent' && amount > 100) return null;
  return { type: type, amount: amount };
}

function hmUpsellBadge(offer) {
  var discount = hmUpsellDiscount(offer);
  if (!discount) return '';
  if (discount.type === 'percent') return '-' + String(discount.amount).replace('.', ',') + '%';
  return '-' + discount.amount.toFixed(2).replace('.', ',') + ' €';
}

function hmUpsellRoot() {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  return root;
}

function hmUpsellLabel(value) {
  var colors = (window.happymamiI18n && window.happymamiI18n.upsell && window.happymamiI18n.upsell.colors) || {};
  var text = String(value || '');
  Object.keys(colors).forEach(function (from) {
    if (text.indexOf(from) !== -1) text = text.split(from).join(colors[from]);
  });
  return text;
}

function hmUpsellRoleName(slot) {
  var role = String((slot && slot.role) || '');
  var item = slot && slot.items && slot.items[0];
  if (!role || role === 'otro') return (item && item.title) || 'Producto';
  return role.charAt(0).toUpperCase() + role.slice(1);
}

// Un pack de la app (varias piezas con su propio color) se ofrece como una sola tarjeta: una opción por pieza y una
// variante por cada combinación. Al añadirlo se envían las piezas sueltas con el mismo _bundle_id, igual que en la
// ficha, para que el pedido muestre qué termo y qué dosificador lleva y la función de checkout fije el precio.
function hmUpsellBundleVariants(pack) {
  var slots = (pack && pack.slots) || [];
  if (!slots.length) return null;
  var groups = slots.map(function (slot) {
    var many = (slot.items || []).length > 1;
    var choices = [];
    (slot.items || []).forEach(function (item) {
      (item.variants || []).forEach(function (variant) {
        if (!variant || variant.available === false) return;
        var label = (variant.options || []).filter(function (o) { return o && o !== 'Default Title'; }).join(' · ');
        if (many) label = (item.title ? item.title + ' · ' : '') + label;
        choices.push({ label: label || item.title || '', id: Number(variant.id), sku: String(variant.sku || ''), qty: slot.qty || 1, role: slot.role || '', image: variant.image || item.image || '', options: (variant.options || []).slice() });
      });
    });
    return choices;
  });
  if (groups.some(function (g) { return !g.length; })) return null;
  var total = groups.reduce(function (n, g) { return n * g.length; }, 1);
  if (total > 100) return null;
  var combos = [[]];
  groups.forEach(function (choices) {
    var next = [];
    combos.forEach(function (combo) {
      choices.forEach(function (choice) { next.push(combo.concat([choice])); });
    });
    combos = next;
  });
  return {
    optionNames: slots.map(hmUpsellRoleName),
    variants: combos.map(function (combo) {
      return {
        id: combo[0].id,
        sku: '',
        available: true,
        price: pack.price,
        options: combo.map(function (c) { return c.label; }),
        image: (combo.filter(function (c) { return c.image; })[0] || {}).image || null,
        lines: combo.map(function (c) { return { id: c.id, sku: c.sku, quantity: c.qty, role: c.role, image: c.image || '', options: c.options }; }),
      };
    }),
  };
}

function hmUpsellBundleItems(variant, offer, extra) {
  var bundle = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  return variant.lines.map(function (line) {
    var props = {
      _bundle_id: bundle,
      _bundle_title: offer.bundle.title,
      _hm_pack: offer.bundle.id,
      _tipo: line.role === 'biberon' && offer.bundle.bottle ? 'vaso' : line.role,
      _hm_locale: offer.bundle.locale || '',
    };
    Object.keys(extra || {}).forEach(function (key) { props[key] = extra[key]; });
    // 2.º biberón: cada pieza lleva lo suyo (vaso: SKU, color y tamaño; tetina: SKU y diseño copiado del carrito).
    var mine = variant.lineProps && variant.lineProps[line.role];
    if (mine) Object.keys(mine).forEach(function (key) { props[key] = mine[key]; });
    return { id: line.id, quantity: line.quantity, properties: props };
  });
}

function hmUpsellApplyBundle(offer, cfg) {
  if (!offer || !offer.productId || !cfg || !cfg.bundlesUrl) return offer;
  var url =
    cfg.bundlesUrl +
    '?product=' + encodeURIComponent(offer.productId) +
    '&market=' + encodeURIComponent(cfg.market || '') +
    '&locale=' + encodeURIComponent(cfg.locale || '') +
    '&mode=generic&detail=1';
  return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      var packs = (data && data.packs) || [];
      var pack = packs.filter(function (p) { return p.id === data.defaultPack; })[0] || packs[0];
      // Solo packs formados por otros productos: un set de la propia pieza (p. ej. 2 tetinas) se añade como producto normal.
      var own = pack && (pack.slots || []).every(function (slot) {
        return (slot.products || []).map(String).indexOf(String(offer.productId)) !== -1;
      });
      if (!pack || own) return offer;
      // Una oferta que copia el diseño solo admite un pack con biberón (vaso + tetina): el 2.º biberón.
      var bottleSlot = (pack.slots || []).filter(function (slot) { return slot && slot.role === 'biberon'; })[0];
      var teatSlot = (pack.slots || []).filter(function (slot) { return slot && slot.role === 'tetina'; })[0];
      if (offer.copyDesign && (!bottleSlot || !teatSlot)) return offer;
      // Las variantes de la app salen de la Admin API e incluyen las que no se venden en este mercado: solo valen las que
      // devuelve la tienda (/products/<handle>.js), como hace la ficha del pack.
      var handles = [];
      pack.slots.forEach(function (slot) {
        (slot.items || []).forEach(function (item) {
          if (item && item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });
      });
      return Promise.all(
        handles.map(function (handle) {
          return fetch(hmUpsellRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          })
            .then(function (response) {
              return response.ok ? response.json() : null;
            })
            .then(function (product) {
              return { handle: handle, variants: (product && product.variants) || null };
            })
            .catch(function () {
              return { handle: handle, variants: null };
            });
        })
      ).then(function (lives) {
        var liveBy = {};
        lives.forEach(function (live) {
          if (live.variants) liveBy[live.handle] = live.variants;
        });
        pack.slots.forEach(function (slot) {
          slot.items = (slot.items || []).filter(function (item) {
            var live = liveBy[item.handle];
            if (!live) return false;
            var byId = {};
            live.forEach(function (variant) {
              byId[String(variant.id)] = variant;
            });
            item.variants = (item.variants || []).filter(function (variant) {
              var l = byId[String(variant.id)];
              if (!l) return false;
              variant.available = variant.available !== false && l.available !== false;
              return true;
            });
            return item.variants.length > 0;
          });
        });
        var built = hmUpsellBundleVariants(pack);
        if (!built) return offer;
        var swatches = Object.assign({}, offer.swatches || {});
        pack.slots.forEach(function (slot) {
          (slot.items || []).forEach(function (item) {
            (item.optionValues || []).forEach(function (option) {
              (option.values || []).forEach(function (value) {
                if (!value || !value.name || !value.color) return;
                swatches[value.name] = value.color.charAt(0) === '#' ? value.color : '#' + value.color;
              });
            });
          });
        });
        offer.swatches = swatches;
        offer.bundle = { id: pack.id, title: pack.title || pack.name || offer.title, locale: cfg.locale || '' };
        if (offer.copyDesign) {
          offer.bundle.bottle = true;
          offer.bundle.bottleIds = (bottleSlot.products || []).map(String);
        }
        offer.optionNames = built.optionNames;
        offer.variants = built.variants;
        offer.copyDesign = !!offer.bundle.bottle;
        return offer;
      });
    })
    .catch(function () {
      return offer;
    });
}

function hmUpsellLocalize(cfg) {
  var offers = (cfg && cfg.offers) || [];
  return Promise.all(
    offers.map(function (offer) {
      if (!offer || !offer.handle) return offer;
      return fetch(hmUpsellRoot() + 'products/' + encodeURIComponent(offer.handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          if (!product) return offer;
          var byId = {};
          (product.variants || []).forEach(function (variant) {
            byId[String(variant.id)] = variant;
          });
          var swatches = Object.assign({}, offer.swatches || {});
          offer.title = product.title || offer.title;
          var cover = product.featured_image;
          offer.image = (cover && (cover.src || cover)) || (product.images && product.images[0]) || '';
          offer.variants = (offer.variants || []).map(function (variant) {
            var live = byId[String(variant.id)];
            if (!live) return variant;
            var previous = variant.options || [];
            var next = live.options || previous;
            previous.forEach(function (name, index) {
              var localized = next[index];
              if (name && localized && swatches[name] && !swatches[localized]) swatches[localized] = swatches[name];
            });
            var image = live.featured_image && live.featured_image.src;
            return Object.assign({}, variant, {
              title: live.title || variant.title,
              options: next,
              image: image || variant.image,
            });
          });
          if (Array.isArray(product.options) && product.options.length) {
            offer.optionNames = product.options.map(function (option) {
              return option && option.name ? option.name : option;
            });
          }
          offer.swatches = swatches;
          return offer;
        })
        .then(function (done) {
          return hmUpsellApplyBundle(done, cfg);
        })
        .catch(function () {
          return offer;
        });
    })
  ).then(function (next) {
    cfg.offers = next;
    return cfg;
  });
}

function hmUpsellOff(offer) {
  var discount = hmUpsellDiscount(offer);
  if (!discount) return '';
  if (discount.type === 'percent') return String(discount.amount) + '%';
  return discount.amount.toFixed(2);
}

var hmUpsellKnownSwatch = {
  'Menta Suave': '#b7d4c8',
  'Rosa Palo': '#e8b4ae',
  'Violeta Seda': '#6f6280',
};

function hmUpsellColorName(name) {
  var label = String(name || '').toLowerCase();
  return (
    label.indexOf('color') !== -1 ||
    label.indexOf('colour') !== -1 ||
    label.indexOf('tono') !== -1 ||
    label.indexOf('colore') !== -1
  );
}

function hmUpsellSwatchColor(offer, value) {
  var map = Object.assign({}, hmUpsellKnownSwatch, (offer && offer.swatches) || {});
  if (map[value]) return map[value];
  var lower = String(value || '').toLowerCase();
  var found = '';
  Object.keys(map).some(function (key) {
    if (key.toLowerCase() !== lower) return false;
    found = map[key];
    return true;
  });
  return found;
}

function hmUpsellIsColor(offer, group) {
  if (hmUpsellColorName(group && group.name)) return true;
  var values = (group && group.values) || [];
  return values.length > 0 && values.every(function (value) {
    return !!hmUpsellSwatchColor(offer, value);
  });
}

function hmUpsellGroups(offer) {
  var variants = offer.variants || [];
  var names = offer.optionNames || [];
  var count = 0;
  variants.forEach(function (variant) {
    count = Math.max(count, (variant.options || []).length);
  });
  var groups = [];
  for (var i = 0; i < count; i++) {
    var values = [];
    variants.forEach(function (variant) {
      var value = (variant.options || [])[i];
      if (!value || values.indexOf(value) !== -1) return;
      values.push(value);
    });
    if (!values.length || (values.length === 1 && values[0] === 'Default Title')) continue;
    groups.push({ index: i, name: names[i] || 'Opción', values: values });
  }
  return groups;
}

function hmUpsellChoiceProps() {
  return {};
}

function hmUpsellByOptions(offer, selected) {
  var variants = (offer.variants || []).filter(function (variant) {
    return variant && variant.available !== false;
  });
  if (!variants.length) variants = offer.variants || [];
  var found = null;
  variants.some(function (variant) {
    var opts = variant.options || [];
    var ok = (selected || []).every(function (value, i) {
      return !value || opts[i] === value;
    });
    if (!ok) return false;
    found = variant;
    return true;
  });
  return found;
}

function hmUpsellVisible(offers, items) {
  var inCart = {};
  (items || []).forEach(function (item) {
    if (item && item.productId != null) inCart[String(item.productId)] = true;
  });
  return (offers || [])
    .filter(function (offer) {
      if (!offer || !offer.productId || !(offer.variants || []).length) return false;
      if (!offer.copyDesign && inCart[String(offer.productId)]) return false;
      if (offer.bundle && (items || []).some(function (item) {
        return item && item.properties && item.properties._hm_pack === offer.bundle.id;
      })) return false;
      if (offer.bundle && offer.bundle.bottle && !hmUpsellBottleDesign(offer, items)) return false;
      // El biberón de la ficha es el escaparate: suelto no se puede comprar (sin vaso ni tetina). Si el pack del
      // 2.º biberón no está o no se ha cargado, la oferta no se enseña en vez de añadir un biberón suelto.
      if (String(offer.handle || '') === 'biberon-personalizado' && !(offer.bundle && offer.bundle.bottle)) return false;
      if (offer.when === 'has' && !inCart[String(offer.whenProductId)]) return false;
      if (offer.when === 'missing' && offer.whenProductId && inCart[String(offer.whenProductId)]) return false;
      return true;
    })
    .sort(function (a, b) {
      return (Number(a.priority) || 1) - (Number(b.priority) || 1);
    });
}

// Ofertas que solo se añaden una vez por pedido (el 2.º biberón): tras añadirla no se deja fijada en el carrito.
function hmUpsellOncePerOrder(offer) {
  return !!(offer && offer.bundle && offer.bundle.bottle);
}

// Un bundle de varias piezas (termo + dosificador) no cabe en la tarjeta del carrito: sus selectores van en un modal.
function hmUpsellNeedsModal(offer, variant) {
  return !!(offer && offer.bundle && !offer.bundle.bottle && variant && variant.lines && variant.lines.length > 1);
}

// Color que más se repite en el carrito (por unidades); en empate, el de la línea más antigua. Solo cuentan los valores
// que son colores conocidos de las ofertas, para no confundir un tamaño o un flujo con un color.
function hmUpsellDominantColor(items, offers) {
  var known = {};
  Object.keys(hmUpsellKnownSwatch).forEach(function (name) {
    known[name.toLowerCase()] = name;
  });
  (offers || []).forEach(function (offer) {
    Object.keys((offer && offer.swatches) || {}).forEach(function (name) {
      known[name.toLowerCase()] = name;
    });
  });
  var counts = {};
  var order = [];
  (items || []).forEach(function (item) {
    var props = (item && item.properties) || {};
    var candidates = [props._hm_color, props.Color, props.Colour, props.Colore, props.Cor].concat((item && item.options) || []);
    var found = '';
    candidates.some(function (value) {
      var key = String(value || '').trim().toLowerCase();
      if (!key || !known[key]) return false;
      found = key;
      return true;
    });
    if (!found) return;
    if (!counts[found]) {
      counts[found] = 0;
      order.push(found);
    }
    counts[found] += Number(item.quantity) || 1;
  });
  var best = '';
  order.forEach(function (key) {
    if (!best || counts[key] > counts[best]) best = key;
  });
  return best;
}

// Marca en la elección de la tarjeta el color dominante, en los grupos que lo ofrecen. Devuelve la variante resultante.
function hmUpsellPreselect(offer, choice, color) {
  if (!color || !choice) return null;
  var changed = false;
  hmUpsellGroups(offer).forEach(function (group) {
    group.values.some(function (value) {
      if (String(value).toLowerCase() !== color) return false;
      choice[group.index] = value;
      changed = true;
      return true;
    });
  });
  return changed ? hmUpsellByOptions(offer, choice) : null;
}

function hmUpsellCover(offer, variant) {
  return (offer && offer.bundle && offer.image) || (variant && variant.image) || '';
}

function hmMsg(path, fallback, vars) {
  if (typeof window.hmT === 'function') {
    var t = window.hmT(path, vars);
    if (t) return t;
  }
  return fallback;
}

if (typeof document === 'undefined') {
  var teat = {
    productId: 10,
    priority: 1,
    when: 'has',
    whenProductId: 20,
    copyDesign: true,
    variants: [
      { id: 1, sku: 'T1L', available: true, options: ['1', 'L'], price: '0 €' },
      { id: 2, sku: 'T2M', available: true, options: ['2', 'M'], price: '0 €', image: 't2.jpg' },
    ],
  };
  var termo = {
    productId: 30,
    priority: 2,
    when: 'has',
    whenProductId: 20,
    copyDesign: false,
    variants: [{ id: 3, sku: 'TER1M', available: true, options: ['Menta Suave'], price: '19,95 €' }],
  };
  var cart = [
    { productId: 20, sku: 'V1R', properties: { _bundle_id: 'abc', Color: 'Rosa Palo', 'Tamaño': '150ml' } },
    {
      productId: 10,
      sku: 'T2M',
      properties: { _bundle_id: 'abc', Tetina: 'T2M', 'Forma del pecho': '2', 'Código regalo': 'X' },
    },
  ];
  var shown = hmUpsellVisible([termo, teat], cart);
  if (shown[0].productId !== 10 || shown.length !== 2) throw new Error('priority');
  var picked = hmUpsellPick(teat, cart);
  if (picked.variant.id !== 2) throw new Error('sku');
  if (picked.properties.Tetina !== 'T2M' || picked.properties['Forma del pecho'] !== '2') throw new Error('design');
  if (picked.properties._bundle_id || picked.properties['Código regalo']) throw new Error('private');
  if (hmUpsellVisible([termo], [{ productId: 30, properties: {} }]).length !== 0) throw new Error('in cart');
  if (hmUpsellVisible([teat], [{ productId: 99, properties: {} }]).length !== 0) throw new Error('condition');
  var cup = hmUpsellPick(
    {
      copyDesign: true,
      variants: [
        { id: 8, sku: 'V1M', available: true, options: ['150ml', 'Menta Suave'] },
        { id: 9, sku: 'V1R', available: true, options: ['150ml', 'Rosa Palo'] },
      ],
    },
    cart
  );
  if (cup.variant.id !== 9 || cup.properties.Color !== 'Rosa Palo') throw new Error('color');
  if (hmUpsellBadge({ discountType: 'percent', discountValue: '10' }) !== '-10%') throw new Error('percent');
  if (hmUpsellBadge({ discountType: 'fixed', discountValue: '5,5' }) !== '-5,50 €') throw new Error('fixed');
  if (hmUpsellBadge({ discountType: 'none', discountValue: '10' }) !== '') throw new Error('none');
  if (hmUpsellOff({ discountType: 'percent', discountValue: '10' }) !== '10%') throw new Error('off');
  var groups = hmUpsellGroups({
    optionNames: ['Color'],
    variants: [
      { options: ['Menta Suave'] },
      { options: ['Rosa Palo'] },
    ],
  });
  if (groups.length !== 1 || groups[0].values[0] !== 'Menta Suave' || groups[0].name !== 'Color') throw new Error('groups');
  if (hmUpsellByOptions(termo, ['Menta Suave']).id !== 3) throw new Error('first option');
  if (hmUpsellGroups({ variants: [{ options: ['Default Title'] }] }).length !== 0) throw new Error('default title');
  if (!hmUpsellIsColor({ swatches: {} }, { name: 'Color', values: ['Arena'] })) throw new Error('color name');
  if (hmUpsellIsColor({}, { name: 'Tamaño', values: ['150ml'] })) throw new Error('size pill');
  if (hmUpsellSwatchColor({}, 'Rosa Palo') !== '#e8b4ae') throw new Error('swatch');
  if (hmUpsellSwatchColor({ swatches: { 'Rosa Palo': 'url(https://cdn.example/rosa.jpg)' } }, 'Rosa Palo') !== 'url(https://cdn.example/rosa.jpg)') throw new Error('swatch image');
  var packBuilt = hmUpsellBundleVariants({
    price: '27,95 €',
    slots: [
      { role: 'termo', qty: 1, items: [{ title: 'Termo', variants: [{ id: 1, options: ['Menta Suave'], available: true }, { id: 2, options: ['Rosa Palo'], available: true }] }] },
      { role: 'dosificador', qty: 1, items: [{ title: 'Dosificador', variants: [{ id: 3, options: ['Menta Suave'], available: true }, { id: 4, options: ['Rosa Palo'], available: true }] }] },
    ],
  });
  if (packBuilt.optionNames.join() !== 'Termo,Dosificador' || packBuilt.variants.length !== 4) throw new Error('bundle-variants');
  var rosa = packBuilt.variants.filter(function (v) { return v.options.join() === 'Rosa Palo,Rosa Palo'; })[0];
  var bundleItems = hmUpsellBundleItems(rosa, { bundle: { id: 'p1', title: 'Pack', locale: 'es' } }, { _hm_upsell: '9' });
  if (bundleItems.length !== 2 || bundleItems[0].id !== 2 || bundleItems[1].id !== 4) throw new Error('bundle-lines');
  if (bundleItems[0].properties._bundle_id !== bundleItems[1].properties._bundle_id || bundleItems[1].properties._tipo !== 'dosificador' || bundleItems[0].properties._hm_upsell !== '9') throw new Error('bundle-props');
  if (!hmUpsellNeedsModal({ bundle: { id: 'p1' } }, rosa) || hmUpsellNeedsModal({ bundle: { id: 'p1' } }, { lines: [{ id: 1 }] }) || hmUpsellNeedsModal({}, rosa)) throw new Error('modal');
  var dominant = hmUpsellDominantColor(
    [
      { options: ['150ml', 'Menta Suave'], quantity: 1, properties: {} },
      { options: ['Rosa Palo'], quantity: 1, properties: {} },
      { options: ['Rosa Palo'], quantity: 1, properties: { _hm_color: 'Rosa Palo' } },
      { options: ['Default Title'], quantity: 1, properties: {} },
    ],
    []
  );
  if (dominant !== 'rosa palo') throw new Error('dominant');
  if (hmUpsellDominantColor([{ options: ['Menta Suave'], quantity: 1, properties: {} }, { options: ['Rosa Palo'], quantity: 1, properties: {} }], []) !== 'menta suave') throw new Error('dominant tie');
  var termoChoice = ['Menta Suave'];
  var termoPick = hmUpsellPreselect({ variants: [{ id: 3, options: ['Menta Suave'] }, { id: 4, options: ['Rosa Palo'] }], optionNames: ['Color'] }, termoChoice, 'rosa palo');
  if (!termoPick || termoPick.id !== 4 || termoChoice[0] !== 'Rosa Palo') throw new Error('preselect');
  if (hmUpsellPreselect(termo, ['Menta Suave'], 'violeta seda') !== null) throw new Error('preselect none');
  if (hmUpsellVisible([{ productId: 7, bundle: { id: 'p1' }, variants: [{ id: 1 }] }], [{ productId: 3, properties: { _hm_pack: 'p1' } }]).length !== 0) throw new Error('bundle-in-cart');
  // 2.º biberón: vaso + tetina con el diseño del carrito, a precio de pack (sin descuento suelto)
  var pairPack = {
    price: '19,95 €',
    slots: [
      { role: 'biberon', qty: 1, products: ['20'], items: [{ title: 'Vaso', variants: [
        { id: 11, sku: 'V2V', options: ['250ml', 'Violeta Seda'] },
        { id: 12, sku: 'V1R', options: ['150ml', 'Rosa Palo'] },
      ] }] },
      { role: 'tetina', qty: 1, products: ['10'], items: [{ title: 'Tetina', variants: [
        { id: 21, sku: 'T1M', options: ['1', 'M'] },
        { id: 22, sku: 'T2M', options: ['2', 'M'] },
      ] }] },
    ],
  };
  var pairBuilt = hmUpsellBundleVariants(pairPack);
  var second = {
    productId: 99,
    priority: 1,
    when: 'has',
    whenProductId: 20,
    copyDesign: true,
    discountType: 'fixed',
    discountValue: '10',
    bundle: { id: 'segundo', title: 'Segundo biberón', locale: 'es', bottle: true, bottleIds: ['20'] },
    variants: pairBuilt.variants,
  };
  var oneBottle = {
    productId: 20,
    sku: 'V2V',
    quantity: 1,
    options: ['250ml', 'Violeta Seda'],
    properties: { _bundle_id: 'x', _hm_pack: 'one', Vaso: 'V2V · Violeta Seda · 250ml', Tétine: 'T1M', _hm_choice: '2111', 'Forma del pecho': '2' },
  };
  var secondPick = hmUpsellPick(second, [oneBottle]);
  if (!secondPick.variant || secondPick.variant.lines[0].id !== 11 || secondPick.variant.lines[1].id !== 21) throw new Error('second-pick');
  if (secondPick.variant.price !== '19,95 €') throw new Error('second-price');
  var secondItems = hmUpsellBundleItems(secondPick.variant, second, { _hm_upsell: '5' });
  if (secondItems.length !== 2 || secondItems[0].properties._bundle_id !== secondItems[1].properties._bundle_id) throw new Error('second-group');
  if (secondItems[0].properties._hm_pack !== 'segundo' || secondItems[0].properties._tipo !== 'vaso' || secondItems[1].properties._tipo !== 'tetina') throw new Error('second-tipo');
  if (secondItems[0].properties._hm_vaso !== 'V2V' || secondItems[0].properties._hm_color !== 'Violeta Seda' || secondItems[0].properties._hm_size !== '250ml') throw new Error('second-cup');
  if (secondItems[1].properties._hm_tetina !== 'T1M' || secondItems[1].properties._hm_choice !== '2111' || secondItems[1].properties['Forma del pecho'] !== '2') throw new Error('second-teat');
  if (secondItems[0].properties._hm_upsell !== '5') throw new Error('second-offer-id');
  if (hmUpsellBadge(second) !== '' || hmUpsellOff(second) !== '' ) throw new Error('second-no-discount');
  if (hmUpsellNeedsModal(second, secondPick.variant)) throw new Error('second-no-modal');
  if (!hmUpsellOncePerOrder(second) || hmUpsellOncePerOrder(teat) || hmUpsellOncePerOrder({ bundle: { id: 'p1' } })) throw new Error('once-per-order');
  if (hmUpsellVisible([second], [oneBottle]).length !== 1) throw new Error('second-visible');
  if (hmUpsellVisible([second], [oneBottle, oneBottle]).length !== 0) throw new Error('second-two-bottles');
  if (hmUpsellVisible([second], [Object.assign({}, oneBottle, { quantity: 2 })]).length !== 0) throw new Error('second-qty');
  if (hmUpsellVisible([second], [Object.assign({}, oneBottle, { properties: Object.assign({}, oneBottle.properties, { _hm_pack: 'two' }) })]).length !== 0) throw new Error('second-set-of-two');
  if (hmUpsellVisible([second], [Object.assign({}, oneBottle, { properties: Object.assign({}, oneBottle.properties, { _hm_pack: 'segundo' }) })]).length !== 0) throw new Error('second-already-added');
  if (hmUpsellPick(second, [Object.assign({}, oneBottle, { sku: 'V1V' })]).variant !== null) throw new Error('second-unknown-sku');
  var showcaseOnly = { productId: 99, handle: 'biberon-personalizado', priority: 1, when: 'always', copyDesign: true, variants: [{ id: 1 }] };
  if (hmUpsellVisible([showcaseOnly], [oneBottle]).length !== 0) throw new Error('showcase-without-pack');
  if (hmUpsellVisible([Object.assign({}, second, { handle: 'biberon-personalizado' })], [oneBottle]).length !== 1) throw new Error('showcase-with-pack');
  if (hmUpsellPick(second, [Object.assign({}, oneBottle, { properties: { _hm_pack: 'one' } })]).variant !== null) throw new Error('second-no-teat');
  var teatHidden = hmUpsellPick(second, [Object.assign({}, oneBottle, { properties: { _hm_pack: 'one', _hm_tetina: 'T2M' } })]);
  if (!teatHidden.variant || teatHidden.variant.lines[1].id !== 22) throw new Error('second-hidden-teat');
  console.log('hm-upsell ok');
} else {
  (function () {
    if (window.__hmUpsell) return;
    window.__hmUpsell = true;
    var timer = null;
    var slides = [];
    var index = 0;
    var pinned = null;
    var touched = false;
    var offersCache = null;
    var offersPending = null;
    var modalOpener = null;

    function rootEl() {
      return document.querySelector('[data-hm-upsell-root]');
    }
    function srcOf(root) {
      return (root && root.getAttribute('data-hm-upsell-src')) || '/apps/hm-menus/upsell';
    }
    function show(next) {
      var root = rootEl();
      var track = root && root.querySelector('[data-hm-upsell-track]');
      if (!root || !track || !slides.length) return;
      index = (next + slides.length) % slides.length;
      track.querySelectorAll('.hm-upsell__card').forEach(function (card, i) {
        card.classList.toggle('is-active', i === index);
      });
    }
    function swapImage(img, src) {
      if (!img || !src || img.getAttribute('src') === src) return;
      var reveal = function () {
        img.classList.remove('is-fading');
      };
      img.classList.add('is-fading');
      img.addEventListener('load', reveal, { once: true });
      window.setTimeout(function () {
        img.src = src;
        if (img.complete) reveal();
      }, 180);
    }
    function play() {
      var root = rootEl();
      if (touched || !root || slides.length < 2) return;
      if (timer) clearInterval(timer);
      var seconds = Number(root.dataset.interval) || 5;
      timer = setInterval(function () {
        show(index + 1);
      }, seconds * 1000);
    }
    function pause() {
      if (timer) clearInterval(timer);
      timer = null;
    }
    function loadOffers(src) {
      if (offersCache) return Promise.resolve(offersCache);
      if (offersPending) return offersPending;
      offersPending = fetch(src, { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cfg) {
          var ready = cfg && Array.isArray(cfg.offers) ? cfg : { offers: [], interval: 5, heading: '' };
          var rootNode = rootEl();
          ready.bundlesUrl = (rootNode && rootNode.getAttribute('data-hm-upsell-bundles')) || '';
          ready.market = (rootNode && rootNode.getAttribute('data-hm-upsell-market')) || '';
          ready.locale = (rootNode && rootNode.getAttribute('data-hm-upsell-locale')) || '';
          return hmUpsellLocalize(ready);
        })
        .then(function (cfg) {
          offersCache = cfg;
          offersPending = null;
          return offersCache;
        })
        .catch(function () {
          offersPending = null;
          return { offers: [], interval: 5, heading: '' };
        });
      return offersPending;
    }
    function paint(root, cfg, cart) {
      pause();
      var dominant = hmUpsellDominantColor(cart, cfg.offers);
      slides = hmUpsellVisible(cfg.offers, cart)
        .map(function (offer) {
          var slide = Object.assign({ offer: offer }, hmUpsellPick(offer, cart || []));
          if (!offer.copyDesign && slide.variant) {
            slide.choice = (slide.variant.options || []).slice();
            var preset = hmUpsellPreselect(offer, slide.choice, dominant);
            if (preset) slide.variant = preset;
            slide.properties = hmUpsellChoiceProps(offer, slide.choice);
          }
          return slide;
        })
        .filter(function (slide) {
          return slide.variant && slide.variant.id;
        });
      index = 0;
      if (pinned && pinned.slide && pinned.slide.offer) {
        var pinId = String(pinned.slide.offer.id || pinned.slide.offer.productId || '');
        var pinAt = -1;
        slides.forEach(function (slide, i) {
          if (String(slide.offer.id || slide.offer.productId || '') === pinId) pinAt = i;
        });
        if (pinAt < 0) {
          pinAt = Math.max(0, Math.min(pinned.index || 0, slides.length));
          slides.splice(pinAt, 0, pinned.slide);
        } else {
          slides[pinAt] = pinned.slide;
        }
        index = pinAt;
      }
      root.hidden = slides.length === 0;
      root.dataset.interval = String(cfg.interval || 5);
      root.classList.toggle('hm-upsell--single', slides.length < 2);
      var heading = root.querySelector('.hm-upsell__title');
      if (heading && cfg.heading && cfg.heading !== 'Completa tu pedido') heading.textContent = cfg.heading;
      var track = root.querySelector('[data-hm-upsell-track]');
      if (!track) return;
      track.innerHTML = '';
      slides.forEach(function (slide, slideIndex) {
        var card = document.createElement('article');
        card.className = 'hm-upsell__card' + (slideIndex === index ? ' is-active' : '');
        var img = document.createElement('img');
        img.alt = '';
        img.loading = 'lazy';
        img.src = hmUpsellCover(slide.offer, slide.variant);
        var body = document.createElement('div');
        body.className = 'hm-upsell__body';
        var title = document.createElement('p');
        title.className = 'hm-upsell__name';
        title.textContent = slide.offer.title || '';
        var price = document.createElement('p');
        price.className = 'hm-upsell__price';
        var amount = document.createElement('span');
        amount.textContent = slide.variant.price || '';
        price.appendChild(amount);
        var badgeText = hmUpsellBadge(slide.offer);
        if (badgeText) {
          var badge = document.createElement('span');
          badge.className = 'hm-upsell__badge';
          badge.textContent = badgeText;
          price.appendChild(badge);
        }
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'button hm-upsell__add';
        button.setAttribute('data-hm-upsell-add', '');
        button.textContent = hmMsg('upsell.add', 'Añadir');
        button.disabled = !slide.variant;
        body.appendChild(title);
        body.appendChild(price);
        var actions = document.createElement('div');
        actions.className = 'hm-upsell__actions';
        var groups = slide.offer.copyDesign || hmUpsellNeedsModal(slide.offer, slide.variant) ? [] : hmUpsellGroups(slide.offer);
        if (!groups.length) actions.classList.add('hm-upsell__actions--end');
        if (groups.length) {
          var choices = document.createElement('div');
          choices.className = 'hm-upsell__choices';
          groups.forEach(function (group) {
            var color = hmUpsellIsColor(slide.offer, group);
            var list = document.createElement('div');
            list.className = color ? 'hm-upsell__swatches' : 'hm-upsell__pills';
            group.values.forEach(function (value) {
              var choice = document.createElement('button');
              choice.type = 'button';
              var selected = (slide.choice || [])[group.index] === value;
              choice.className = (color ? 'hm-upsell__swatch' : 'hm-upsell__pill') + (selected ? ' is-selected' : '');
              choice.setAttribute('data-hm-upsell-option', String(group.index));
              choice.setAttribute('data-value', value);
              choice.setAttribute('aria-label', hmUpsellLabel(value));
              choice.title = hmUpsellLabel(value);
              if (color) {
                var swatch = hmUpsellSwatchColor(slide.offer, value);
                if (swatch.indexOf('url(') === 0) choice.style.backgroundImage = swatch;
                else if (swatch) {
                  choice.style.setProperty('--hm-swatch', swatch);
                  choice.style.backgroundColor = swatch;
                }
              } else {
                choice.textContent = hmUpsellLabel(value);
              }
              list.appendChild(choice);
            });
            choices.appendChild(list);
          });
          choices.addEventListener('click', function (event) {
            var choice = event.target.closest && event.target.closest('[data-hm-upsell-option]');
            if (!choice) return;
            event.preventDefault();
            touched = true;
            pause();
            if (!slide.choice) slide.choice = [];
            slide.choice[Number(choice.getAttribute('data-hm-upsell-option'))] = choice.getAttribute('data-value');
            var list = choice.parentNode;
            list.querySelectorAll('[data-hm-upsell-option]').forEach(function (el) {
              el.classList.toggle('is-selected', el === choice);
            });
            var variant = hmUpsellByOptions(slide.offer, slide.choice);
            slide.variant = variant;
            slide.properties = hmUpsellChoiceProps(slide.offer, slide.choice);
            if (variant && variant.image) swapImage(img, variant.image);
            amount.textContent = variant ? variant.price || '' : '';
            button.disabled = !variant;
          });
          actions.appendChild(choices);
        }
        actions.appendChild(button);
        body.appendChild(actions);
        card.appendChild(img);
        card.appendChild(body);
        track.appendChild(card);
      });
      if (!root.dataset.hmBound) {
        root.dataset.hmBound = '1';
        root.addEventListener('pointerdown', function () {
          touched = true;
          pause();
        });
      }
      play();
    }
    function boot() {
      var root = rootEl();
      var cartEl = document.querySelector('[data-hm-upsell-cart]');
      if (!root || !cartEl) return;
      // Las ofertas (5 /products/*.js, 4 bundles y /upsell) solo se piden cuando el carrito se abre por primera vez,
      // no en cada página al cargar. Si el cajón se abre, el observador de abajo vuelve a llamar a boot().
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && !offersCache && !offersPending && !drawerEl.classList.contains('active')) return;
      var raw = cartEl.textContent || '';
      if (root.dataset.hmBoot === raw) return;
      root.dataset.hmBoot = raw;
      var cart = [];
      try {
        cart = JSON.parse(raw);
      } catch (e) {
        cart = [];
      }
      loadOffers(srcOf(root)).then(function (cfg) {
        var live = rootEl();
        if (!live) return;
        paint(live, cfg, cart);
      });
    }

    document.addEventListener('click', function (event) {
      var root = event.target.closest && event.target.closest('[data-hm-upsell-root]');
      if (!root) return;
      if (event.target.closest('[data-hm-prev]')) {
        pinned = null;
        show(index - 1);
        play();
        return;
      }
      if (event.target.closest('[data-hm-next]')) {
        pinned = null;
        show(index + 1);
        play();
        return;
      }
      var button = event.target.closest('[data-hm-upsell-add]');
      if (!button || button.disabled) return;
      var slide = slides[index];
      if (!slide) return;
      if (hmUpsellNeedsModal(slide.offer, slide.variant)) {
        openModal(slide, root, button);
        return;
      }
      addSlide(slide, root, button, null);
    });

    function addSlide(slide, root, button, done) {
      // El 2.º biberón es uno por pedido: al añadirlo la tarjeta se va, no se queda fijada como las demás.
      pinned = hmUpsellOncePerOrder(slide.offer) ? null : { slide: slide, index: index };
      var properties = Object.assign({}, slide.properties);
      var off = hmUpsellOff(slide.offer);
      if (off) properties._hm_off = off;
      if (slide.offer.id) properties._hm_upsell = String(slide.offer.id);
      button.disabled = true;
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      if (!/\.js(\?|$)/.test(addUrl)) addUrl += '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: slide.variant.lines && slide.offer.bundle
            ? hmUpsellBundleItems(slide.variant, slide.offer, Object.assign({}, properties))
            : [{ id: slide.variant.id, quantity: 1, properties: properties }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error((data && (data.description || data.message)) || hmMsg('upsell.add_error', 'No se ha podido añadir'));
            return data;
          });
        })
        .then(function (data) {
          fetch(srcOf(root), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              offerId: slide.offer.id || '',
              variantId: slide.variant.id,
              productId: slide.offer.productId || '',
              title: slide.offer.title || '',
              when: slide.offer.when || '',
              amount: slide.variant.price || '',
            }),
          }).catch(function () {});
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
          if (done) done(true);
        })
        .catch(function (error) {
          button.disabled = false;
          button.textContent = hmMsg('upsell.add', 'Añadir');
          play();
          if (done) done(false);
          window.alert(error.message || hmMsg('upsell.add_error', 'No se ha podido añadir'));
        });
    }

    function closeModal() {
      var modal = document.querySelector('[data-hm-upsell-modal]');
      if (modal) modal.remove();
      document.removeEventListener('keydown', onModalKey);
      if (modalOpener && document.contains(modalOpener)) modalOpener.focus();
      modalOpener = null;
    }
    function onModalKey(event) {
      if (event.key === 'Escape') closeModal();
    }

    // Elegir las piezas de un bundle: una fila por pieza (termo, dosificador…) y, al confirmar, se añaden todas juntas.
    function openModal(slide, root, opener) {
      closeModal();
      touched = true;
      pause();
      modalOpener = opener;
      var offer = slide.offer;
      var choice = (slide.choice || (slide.variant.options || []).slice()).slice();
      var variant = slide.variant;

      var overlay = document.createElement('div');
      overlay.className = 'hm-upsell-modal';
      overlay.setAttribute('data-hm-upsell-modal', '');
      var dialog = document.createElement('div');
      dialog.className = 'hm-upsell-modal__dialog';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'hm-upsell-modal-title');

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'hm-upsell-modal__close';
      close.setAttribute('aria-label', hmMsg('upsell.close', 'Cerrar'));
      close.textContent = '×';
      close.addEventListener('click', closeModal);

      var head = document.createElement('div');
      head.className = 'hm-upsell-modal__head';
      var img = document.createElement('img');
      img.alt = '';
      img.src = hmUpsellCover(offer, variant);
      var heading = document.createElement('div');
      var title = document.createElement('p');
      title.id = 'hm-upsell-modal-title';
      title.className = 'hm-upsell-modal__title';
      title.textContent = offer.title || '';
      var amount = document.createElement('p');
      amount.className = 'hm-upsell-modal__price';
      amount.textContent = variant.price || '';
      heading.appendChild(title);
      heading.appendChild(amount);
      head.appendChild(img);
      head.appendChild(heading);

      var confirm = document.createElement('button');
      confirm.type = 'button';
      confirm.className = 'button hm-upsell-modal__confirm';
      confirm.textContent = hmMsg('upsell.add', 'Añadir');

      var body = document.createElement('div');
      body.className = 'hm-upsell-modal__groups';
      hmUpsellGroups(offer).forEach(function (group) {
        var color = hmUpsellIsColor(offer, group);
        var row = document.createElement('div');
        row.className = 'hm-upsell-modal__group';
        var label = document.createElement('p');
        label.className = 'hm-upsell-modal__label';
        label.textContent = group.name;
        var list = document.createElement('div');
        list.className = color ? 'hm-upsell__swatches' : 'hm-upsell__pills';
        var pieceImg = document.createElement('img');
        pieceImg.alt = '';
        pieceImg.className = 'hm-upsell-modal__piece';
        var pieceLine = variant.lines && variant.lines[group.index];
        pieceImg.src = (pieceLine && pieceLine.image) || '';
        pieceImg.hidden = !pieceImg.getAttribute('src');
        group.values.forEach(function (value) {
          var option = document.createElement('button');
          option.type = 'button';
          var selected = choice[group.index] === value;
          option.className = (color ? 'hm-upsell__swatch' : 'hm-upsell__pill') + (selected ? ' is-selected' : '');
          option.setAttribute('data-value', value);
          option.setAttribute('aria-label', hmUpsellLabel(value));
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
          option.title = hmUpsellLabel(value);
          if (color) {
            var swatch = hmUpsellSwatchColor(offer, value);
            if (swatch.indexOf('url(') === 0) option.style.backgroundImage = swatch;
            else if (swatch) {
              option.style.setProperty('--hm-swatch', swatch);
              option.style.backgroundColor = swatch;
            }
          } else {
            option.textContent = hmUpsellLabel(value);
          }
          option.addEventListener('click', function () {
            choice[group.index] = value;
            list.querySelectorAll('button').forEach(function (el) {
              var on = el === option;
              el.classList.toggle('is-selected', on);
              el.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            variant = hmUpsellByOptions(offer, choice);
            amount.textContent = variant ? variant.price || '' : '';
            var line = variant && variant.lines && variant.lines[group.index];
            if (line && line.image) {
              pieceImg.hidden = false;
              swapImage(pieceImg, line.image);
            }
            confirm.disabled = !variant;
          });
          list.appendChild(option);
        });
        var pick = document.createElement('div');
        pick.className = 'hm-upsell-modal__pick';
        pick.appendChild(label);
        pick.appendChild(list);
        row.appendChild(pick);
        row.appendChild(pieceImg);
        body.appendChild(row);
      });

      confirm.addEventListener('click', function () {
        if (!variant || confirm.disabled) return;
        confirm.disabled = true;
        slide.variant = variant;
        slide.choice = choice;
        addSlide(slide, root, confirm, function (ok) {
          if (ok) closeModal();
          else confirm.disabled = false;
        });
      });

      dialog.appendChild(close);
      dialog.appendChild(head);
      dialog.appendChild(body);
      dialog.appendChild(confirm);
      overlay.appendChild(dialog);
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeModal();
      });
      document.body.appendChild(overlay);
      document.addEventListener('keydown', onModalKey);
      confirm.focus();
    }

    function watch() {
      boot();
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      new MutationObserver(boot).observe(drawer, { childList: true, subtree: true });
      // Al abrir el cajón (clase active) se cargan las ofertas por primera vez.
      new MutationObserver(boot).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  })();
}
